import type { MailAttachmentPickersProps } from "./components/MailAttachmentPickers";
import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, type LazyComponent, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "MailAttachmentPickers" */ "./lazyIndex"), { name: "MailAttachmentPickers" });

export const MailAttachmentPickers: LazyComponent<MailAttachmentPickersProps, unknown, void> = createLazyComponent(lazyModule, m => m.MailAttachmentPickers);
